import { ITransition } from 'src/app/core/interfaces/onboarding/page-state/transition.interface';
import { PageState } from 'src/app/core/models/page-state/page-state.model';

export abstract class AbstractPageStateService {
  protected abstract getPageStateById(stateId: string): PageState;
  abstract getPageTransitionsByStateId(stateId: string): Promise<ITransition[]>;
  abstract getPageStateByEventAndTransitions(
    eventEnum: number,
    transitions: ITransition[]
  ): PageState;
  abstract getCurrentPageState(stateId: string): Promise<PageState>;
}
